import "@css/Subscription.css";

/**
 * SubscriptionSkeleton - Loading skeleton for subscription status
 */
const SubscriptionSkeleton = () => {
    return (
        <div className="subscription-skeleton">
            <div className="subscription-skeleton-item tall" />
            <div className="subscription-skeleton-item" />
            <div className="subscription-skeleton-item" />
            <div className="subscription-skeleton-item" />
        </div>
    );
};

SubscriptionSkeleton.propTypes = {};

export default SubscriptionSkeleton;
